import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class ContactCell extends GridCell {
  render () {
    let value = this.props.dataItem.value
    let contactType = this.props.dataItem.type.code.toLowerCase()
    return (<td><span className={'contact-cell-' + contactType}>{value}</span></td>)
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/contactCell.js